__webpack_require__.p = "https://assets.simple.life/static/v0.192.0/";